import React, { useEffect, useRef } from 'react';

const ContactEnquiryFormSuccessUI = () => {
  const successWrapperRef = useRef(null);

  useEffect(() => {
    successWrapperRef?.current?.scrollIntoView({
      block: 'center',
      inline: 'center',
    });
  }, []);

  return (
    <div
      className="text-center text-gray mt-32 mx-0 mb-40"
      ref={successWrapperRef}
    >
      <h1 className="mb-6 text-2xl font-bold">
        Thank you! We’ve received your request.
      </h1>

      <p className="mb-6 text-sm">
        A representative will get back to you in 1-3 business days.
      </p>
    </div>
  );
};

export default ContactEnquiryFormSuccessUI;
